var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _vm.currentFields.length > 0
        ? _c(
            "v-card",
            { staticClass: "mx-4 my-0", attrs: { flat: "", tile: "" } },
            [
              _vm.title
                ? _c("v-card-title", [
                    _c("span", { staticStyle: { "font-size": "18px" } }, [
                      _vm._v(_vm._s(_vm.title))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-text",
                { style: !_vm.title ? "padding-top: 10px" : null },
                [
                  _c(
                    "v-form",
                    { ref: "form", attrs: { "lazy-validation": "" } },
                    [
                      _c(
                        "v-row",
                        [
                          _vm.fields === "details"
                            ? _c(
                                "v-col",
                                {
                                  staticStyle: {
                                    "max-width": "700px",
                                    "padding-top": "10px",
                                    "padding-bottom": "10px"
                                  },
                                  attrs: { cols: "6" }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Description",
                                      rules: [_vm.rules.required],
                                      readonly: _vm.readOnlyItem,
                                      required: "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "auto",
                                      "validate-on-blur": "",
                                      "persistent-hint": "",
                                      hint: !_vm.readOnlyItem
                                        ? "*required"
                                        : null
                                    },
                                    model: {
                                      value: _vm.value.description,
                                      callback: function($$v) {
                                        _vm.$set(_vm.value, "description", $$v)
                                      },
                                      expression: "value.description"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.currentFields, function(field, ind) {
                            return _c(
                              "v-col",
                              {
                                key: ind,
                                staticStyle: {
                                  "padding-top": "10px",
                                  "padding-bottom": "10px"
                                },
                                attrs: { cols: "auto" }
                              },
                              [
                                field.value === "source"
                                  ? _c("v-autocomplete", {
                                      attrs: {
                                        label: "Source",
                                        items: _vm.itemSources,
                                        "item-text": "display_name",
                                        "item-value": "source_id",
                                        rules: [_vm.rules.required],
                                        readonly: _vm.readOnlyItem,
                                        required: "",
                                        outlined: "",
                                        dense: "",
                                        "persistent-hint": "",
                                        hint: !_vm.readOnlyItem
                                          ? "*required"
                                          : null,
                                        "hide-details": "auto",
                                        "validate-on-blur": ""
                                      },
                                      model: {
                                        value: _vm.value.source,
                                        callback: function($$v) {
                                          _vm.$set(_vm.value, "source", $$v)
                                        },
                                        expression: "value.source"
                                      }
                                    })
                                  : field.meta === true &&
                                    field.value === "allergen"
                                  ? [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: field.key + "-always",
                                                  disabled:
                                                    field.disabled || false,
                                                  readonly: _vm.readOnlyItem,
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": "auto"
                                                },
                                                model: {
                                                  value:
                                                    _vm.value.metadata[
                                                      "allergen"
                                                    ]["A"],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.value.metadata[
                                                        "allergen"
                                                      ],
                                                      "A",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "value.metadata['allergen']['A']"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: field.key + "-warning",
                                                  disabled:
                                                    field.disabled || false,
                                                  readonly: _vm.readOnlyItem,
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": "auto"
                                                },
                                                model: {
                                                  value:
                                                    _vm.value.metadata[
                                                      "allergen"
                                                    ]["W"],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.value.metadata[
                                                        "allergen"
                                                      ],
                                                      "W",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "value.metadata['allergen']['W']"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  : field.meta === true
                                  ? _c("v-text-field", {
                                      attrs: {
                                        label: field.key,
                                        disabled: field.disabled || false,
                                        readonly: _vm.readOnlyItem,
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "auto"
                                      },
                                      model: {
                                        value:
                                          _vm.value.metadata["" + field.value],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.value.metadata,
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "value.metadata[`${field.value}`]"
                                      }
                                    })
                                  : field.derived === true
                                  ? _c("v-text-field", {
                                      attrs: {
                                        label: field.key,
                                        disabled: field.disabled || false,
                                        readonly: _vm.readOnlyItem,
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "auto"
                                      },
                                      model: {
                                        value:
                                          _vm.value.metadata.derived[
                                            "" + field.value
                                          ],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.value.metadata.derived,
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "value.metadata.derived[`${field.value}`]"
                                      }
                                    })
                                  : field.tenant_meta === true
                                  ? _c("v-text-field", {
                                      attrs: {
                                        label: field.key,
                                        disabled: field.disabled || false,
                                        readonly: _vm.readOnlyItem,
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "auto"
                                      },
                                      model: {
                                        value:
                                          _vm.value.metadata[
                                            _vm.tenantMetadataKey[
                                              _vm.$auth.tenant
                                            ]
                                          ]["" + field.value],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.value.metadata[
                                              _vm.tenantMetadataKey[
                                                _vm.$auth.tenant
                                              ]
                                            ],
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "value.metadata[tenantMetadataKey[$auth.tenant]][`${field.value}`]"
                                      }
                                    })
                                  : field.value === "upc" ||
                                    field.value === "plu"
                                  ? _c("v-text-field", {
                                      ref: field.value,
                                      refInFor: true,
                                      attrs: {
                                        label: field.key,
                                        disabled: field.disabled || false,
                                        readonly: _vm.readOnlyItem,
                                        rules: [_vm.validUpcOrPlu],
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        "error-messages":
                                          field.value === "upc" &&
                                          _vm.upcRes &&
                                            !_vm.upcRes.original_is_valid
                                            ? "" + _vm.upcRes.message
                                            : [],
                                        "persistent-hint": "",
                                        hint: !_vm.readOnlyItem
                                          ? "*Either UPC or PLU is required"
                                          : null,
                                        "validate-on-blur": ""
                                      },
                                      on: {
                                        blur: _vm.handleBlur,
                                        keyup: function($event) {
                                          return _vm.handleKeyUp(field.value)
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "message",
                                            fn: function() {
                                              return [
                                                field.value === "upc" &&
                                                _vm.upcRes &&
                                                  !_vm.upcRes
                                                    .original_is_valid &&
                                                  _vm.upcRes.standardized_upc
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          display:
                                                            "inline-block"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                " +
                                                            _vm._s(
                                                              _vm.upcRes.message
                                                            ) +
                                                            ".\n                "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#333"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  Did you mean:\n                  "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "font-weight":
                                                                    "500"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      _vm.upcRes
                                                                        .standardized_upc
                                                                    ) +
                                                                    "?\n                  "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              "x-small": "",
                                                              color: "success",
                                                              outlined: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.updateUpc(
                                                                  _vm.upcRes
                                                                    .standardized_upc
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  Yes\n                "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.value["" + field.value],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.value,
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression: "value[`${field.value}`]"
                                      }
                                    })
                                  : field.value === "shipping_cube" ||
                                    field.value === "shipping_unit_weight"
                                  ? _c("v-text-field", {
                                      attrs: {
                                        value: parseFloat(
                                          _vm.value.metadata["" + field.value]
                                        ).toFixed(2),
                                        type: field.hasOwnProperty("type")
                                          ? field.type
                                          : "text",
                                        label: field.key,
                                        disabled: field.disabled || false,
                                        rules: field.required
                                          ? [_vm.rules.required]
                                          : [],
                                        required: field.required || false,
                                        readonly: _vm.readOnlyItem,
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        "validate-on-blur": "",
                                        prefix: field.prefix || null
                                      }
                                    })
                                  : field.value === "balance_on_hand_qty"
                                  ? _c("v-text-field", {
                                      attrs: {
                                        type: field.hasOwnProperty("type")
                                          ? field.type
                                          : "text",
                                        label: field.key,
                                        disabled: field.disabled || false,
                                        rules: field.required
                                          ? [_vm.rules.required]
                                          : [],
                                        required: field.required || false,
                                        readonly: _vm.readOnlyItem,
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        "validate-on-blur": "",
                                        prefix: field.prefix || null
                                      },
                                      model: {
                                        value:
                                          _vm.value.metadata["" + field.value],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.value.metadata,
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "value.metadata[`${field.value}`]"
                                      }
                                    })
                                  : field.value === "status" && _vm.argDsdItem
                                  ? _c("v-autocomplete", {
                                      attrs: {
                                        label: field.key,
                                        items: _vm.statusList,
                                        readonly: !_vm.hasWriteAccess,
                                        outlined: "",
                                        dense: "",
                                        "validate-on-blur": ""
                                      },
                                      model: {
                                        value: _vm.value.status,
                                        callback: function($$v) {
                                          _vm.$set(_vm.value, "status", $$v)
                                        },
                                        expression: "value.status"
                                      }
                                    })
                                  : _c("v-text-field", {
                                      attrs: {
                                        type: field.hasOwnProperty("type")
                                          ? field.type
                                          : "text",
                                        label: field.key,
                                        disabled: field.disabled || false,
                                        rules: field.required
                                          ? [_vm.rules.required]
                                          : [],
                                        required: field.required || false,
                                        readonly: _vm.readOnlyItem,
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        "persistent-hint": "",
                                        hint:
                                          field.value === "item_id" &&
                                          !_vm.readOnlyItem
                                            ? "*required"
                                            : "",
                                        "validate-on-blur": "",
                                        prefix: field.prefix || null
                                      },
                                      model: {
                                        value: _vm.value["" + field.value],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.value,
                                            "" + field.value,
                                            $$v
                                          )
                                        },
                                        expression: "value[`${field.value}`]"
                                      }
                                    })
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45942efc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45942efc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/ItemData.vue
// module id = null
// module chunks = 